import { Navigate } from '@sorare/routing';
import { FOOTBALL_ONBOARDING_TUTORIAL_RECRUIT } from '@sorare/core/src/constants/__generated__/routes';

const TutorialPage = () => {
  return <Navigate to={FOOTBALL_ONBOARDING_TUTORIAL_RECRUIT} replace />;
};
export default TutorialPage;
